export const ENDPOINTS = {
  GET_ASSETS: '/api/tokens',
};
